import React from "react";
import BubblesBg from "components/BubblesBg";
import { Helmet } from "react-helmet";
const Bubbles = () => {
  return (
    <>
      <Helmet>
        <title>bubbles</title>
      </Helmet>
      <BubblesBg />
    </>
  );
};

export default Bubbles;
